import type { IconData } from '@stacksjs/iconify-core'

export const chevronSquareDownLeftF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 11V6a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronSquareDownLeftF
